module.exports = __webpack_public_path__ + "img/2.b40a96cc.png";